<template>
  <div>
    <AppHeaderCv :dataHead="data.INFO" v-if="data.INFO.DOWNLOAD !== []"/>
    <div class="profile-page">
      <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>
      <section class="section section-skew" style="padding-bottom: 0px">
        <div class="container">
          <card class="card-profile mt--300" no-body shadow>
            <div class="px-4">
              <div class="row">
                <div class="col-md-4 col-12">
                  <img class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                       style="width: 200px;"
                       v-lazy="'img/'+ data.INFO.image">
                </div>
                <div class="col-md-8 offset-md-0 col-10 offset-1 mt-4 mb-3">
                  <div class="d-none d-sm-block">

                    <h1 class="mb-4">
                      <span>{{ data.INFO.nomPrenom }}</span>
                    </h1>
                    <h3 class="mb-0">
                      <span>{{ data.INFO.status }}, {{ age }} ans {{ data.INFO.entete }}</span>
                    </h3>
                    <small class="text-muted">{{ data.INFO.description }}</small>
                  </div>
                  <div class="d-block d-sm-none text-center  mb-4">
                    <h1 class="pb-4">
                      <span>{{ data.INFO.nomPrenom }}</span>
                    </h1>
                    <h3 class="">
                      <span>{{ data.INFO.status }}, {{ age }} ans {{ data.INFO.entete }}</span>
                    </h3>
                    <small class="text-muted">{{ data.INFO.description }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 offset-md-0 col-11 container ">
                  <div class="row justify-content-center pb-4">
                    <div class=" col-md-11 col-lg-9 col-9 col-xl-8 text-center">
                      <p class="lead mb-1 mt-1"><i class="fa fa-phone"></i><a
                          :href="'tel:' + data.INFO.tel"> {{ data.INFO.tel }}</a></p>
                    </div>
                    <div class="  col-md-12 col-lg-12 col-xl-11 col-12 col-sm-9 text-center">
                      <p class="lead mb-1 mt-1"><i class="fa fa-envelope"></i><a
                          :href="'mailto:' + data.INFO.mail"> {{ data.INFO.mail }}</a>
                      </p>
                    </div>
                    <div class=" col-md-11 col-lg-10 col-xl-11 col-10">
                      <p class="lead  mb-1 mt-1 text-center"><i class="fa fa-map-marker"></i>
                        <a :href="'https://www.google.com/maps/search/?api=1&query=' +  data.INFO.addresse"
                           target="_blank"> {{ data.INFO.addresse }}</a>
                      </p>
                    </div>
                    <div class=" col-md-11 col-lg-10 col-xl-11 col-10">
                      <p class="lead  mb-1 mt-1 text-center"><i class="fas fa-network-wired"></i>
                        <a :href="'https://cv.guillet.app'"
                           target="_blank"> cv.guillet.app</a>
                      </p>
                    </div>

                  </div>
                  <div class="row mt-1">
                    <h4 class="text-center titreGauche titre">CENTRES D'INTERET <i
                        class="fa-solid fa-umbrella-beach"></i>
                    </h4>
                    <ul class="col-12">
                      <li :key="item.id" class="interligne" v-for="item in data.CENTRESINTERET">
                        <i class="fas fa-caret-right mr-2"></i> {{ item }}
                      </li>
                    </ul>

                  </div>
                  <div class="row mt-1">
                    <h4 class="text-center titreGauche titre">QUALITES <i class="fa-solid fa-angles-up"></i>
                    </h4>
                    <ul class="col-12">
                      <li :key="item.id" class="interligne" v-for="item in data.QUALITES">
                        <i class="fas fa-caret-right mr-2"></i> {{ item }}
                      </li>
                    </ul>

                  </div>
<!--                  <div class="row mt-1">-->
<!--                    <h4 class="titreDroite titre mt-4">COMPETENCES <i class="fa fa-cogs"></i>-->
<!--                    </h4>-->
<!--                    <ul>-->
<!--                      <li :key="item.id" class="interligne" v-for="item in data.COMPETENCES">-->
<!--                        {{ item }}-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
                  <div class="row mt-1">

                    <h4 class="text-center titreGauche titre">ECOLES <i class="fa-solid fa-school"></i>
                    </h4>
                    <ul class="col-12">
                      <li :key="item.id" class="interligne" v-for="item in data.FORMATIONS">
                        <i class="fas fa-caret-right mr-2"></i> {{ item }}
                      </li>
                    </ul>

                  </div>
                  <div class="row mt-1">
                    <h4 class="text-center titreGauche titre">DIPLOMES <i class="fa fa-graduation-cap"></i>
                    </h4>
                    <ul class="col-12">
                      <li :key="item.id" class="interligne" v-for="item in data.DIPLOMES">
                        <i class="fas fa-caret-right mr-2"></i> {{ item }}
                      </li>
                    </ul>

                  </div>
                </div>
                <div class="col-md-8 col-12">
                  <div class="row">
                    <div class="col-lg-6 col-12">
                      <div class="row">
                        <div class="col-12">
                          <h4 id="titreDroite" class="titre text-center">EXPERIENCES <i class="fa fa-briefcase"></i></h4>
                          <div class="row mb-3">
                            <bloc-experience :key="item.id" v-bind:list="item.list"
                                             v-bind:titre="item.titre"
                                             v-for="item in data.EXPERIENCES"></bloc-experience>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="row">
                        <div class="col-12">
                          <h4 class="text-center titreGauche titre">Outils de travail <i
                              class="fab fa-docker"></i>
                          </h4>
                          <ul class="row">
                            <li :key="item.id" class="interligne col-6 pl-0"
                                v-for="item in data.Stach_de_travail"><i class="fas fa-caret-right mr-2"></i> {{ item }}
                            </li>
                          </ul>

                        </div>
                        <div class="col-12">
                          <h4 class="text-center titreGauche titre">Langages <i class="fa-brands fa-php"></i>
                          </h4>
                          <ul class="col-12">
                            <li :key="item.id" class="interligne"
                                v-for="(item, key) in data.Langage"><strong>{{ key }}</strong>: {{ item }}
                            </li>
                          </ul>

                        </div>
                        <div class="col-12">
                          <h4 class="text-center titreGauche titre">Frameworks <i class="fa-brands fa-symfony"></i>
                          </h4>
                          <ul class="col-12">
                            <li :key="item.id" class="interligne"
                                v-for="(item, key) in data.Framework"><strong>{{ key }}</strong>: {{ item }}
                            </li>
                          </ul>

                        </div>
                        <div class="col-12">
                          <h4 class="text-center titreGauche titre">Technologies <i class="fa-solid fa-memory"></i>
                          </h4>
                          <ul class="col-12">
                            <li :key="item.id" class="interligne"
                                v-for="(item, key) in data.Technologie"><strong>{{ key }}</strong>: {{ item }}
                            </li>
                          </ul>

                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <h4 class="text-center titreGauche titre">Projets <i class="fa-solid fa-arrow-up-right-dots"></i>
                      </h4>
                      <ul class="col-12">
                        <li :key="item.id" class="interligne"
                            v-for="(item, key) in data.Projet"><a :href="item.url" target="_blank"><strong>{{
                            key
                          }} :</strong></a> {{ item.description }}
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>

  </div>
</template>

<script>
import BlocExperience from "../components/custom/BlocExperience";
import AppHeaderCv from "../layout/AppHeaderCv"

export default {
  components: {
    AppHeaderCv,
    BlocExperience,
  },
  data() {
    return {
      data: {
        "EXPERIENCES": [{"titre": "Chargement ...", "list": []}],
        "COMPETENCES": [],
        "DIPLOMES": [],
        "FORMATIONS": [],
        "INFO": {
          "tel": "",
          "mail": "",
          "addresse": "",
          "nomPrenom": "",
          "image": "",
          "status": "",
          "entete": "",
          "dateNe": 2019,
          "DOWNLOAD": [],
        }
      },
      age: null
    }
  },
  created: function () {
    $.getJSON('/data/cv.json', (data) => {
      this.data = data;
      this.age = new Date().getFullYear() - new Date(this.data.INFO.dateNe).getFullYear()
    });
    this.$root.$on('downloadPdf', () => {
      this.print();
    });
  },
  methods: {
    downloadWithCSS() {
      /* en cours
      const doc = new jsPDF();
      let content = this.$el.children[1].children[1].children[0];
      /** WITH CSS
      html2canvas(content, {scale: 0.7}).then(function (canvas) {
          console.log(canvas);
          const img = canvas.toDataURL("image/jpeg", 0.8);
          doc.addImage(img,'JPEG',10,10);
          doc.save("sample.pdf");
      });

       */
    },
    print() {
      window.print();
    }
  }
}

</script>

<style scoped>
.interligne {
  padding-top: 5px;
}

.titreGauche {
  width: 95%;
}

@media (min-width: 768px) {
  h4#titreDroite {
    text-align: initial!important;
  }
}

.titre {
  border-bottom: 2px solid;
}

.mt--300 {
  margin-top: -500px !important;
  padding-top: 20px;
}

@media (max-width: 992px) {
  .mt--300 {
    margin-top: -330px !important;
  }
}

@media (max-width: 765px) {
  .mt--300 {
    margin-top: -230px !important;
  }

  .px-4 {
    margin-top: -100px;
  }
}

ul {
  list-style: none;
}
</style>